import { Col, Row } from "react-bootstrap";
import parse from "html-react-parser";
import alrajhi_logo from "assets/images/alrajhi_logo.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { newsList as localNewsList } from "constants/full_news";
import { useEffect, useState } from "react";
import "./news.css";
import axios from "axios";
import { isArray } from "lodash";
import moment from "moment";

function ViewNews() {
  const { slug } = useParams();
  const [news, setNews] = useState(null);
  const [newsList, setNewsList] = useState(localNewsList);
  const navigate = useNavigate();

  const fetchNewsAndAnnouncementsCMS = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/news-and-announcements?sort=createdAt:desc&populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    const fetchAdditionalData = async () => {
      try {
        const response = await fetch(
          "https://www.alrajhibank.com.my/assets/json/news.json"
        );
        const fetchedData = await response.json();
        const fetchDataCMS = await fetchNewsAndAnnouncementsCMS();
        const formattedCMSData = isArray(fetchDataCMS) && fetchDataCMS.map(data => ({
          // id: data.id,
          type: data.type || "News",
          title: data.title,
          date: moment(data.date).format("DD MMM YYYY"),
          tag: data.yearTag,
          slug: data.slug,
          description: data.contentTemplate,
          image: data.image,
          isFromCMS: true,
        }));

        const mergedData = [...formattedCMSData, ...fetchedData.newsList, ...localNewsList];
        setNewsList(mergedData);

        const foundNews = mergedData.find((item) => item.slug === slug);
        console.log(foundNews);
        if (foundNews) {
          setNews(foundNews);
        } else {
          navigate("");
        }
      } catch (error) {
        console.error("Error fetching news data:", error);
        navigate("/error");
      }
    };

    fetchAdditionalData();
  }, [slug, navigate]);

  if (!news) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="container page">
        <Row>
          <Col md={8} xs={12} className="news-view">
            <h1 className="title">{news.title}</h1>
            <p className="date">{news.date}</p>
            <p className="content">{parse(news.description)}</p>
          </Col>
          <Col md={4} xs={12} className="sidebar">
            {/* <h1 className="title">Latest News Archive</h1> */}

            {/* <div className="seen-box">
              <Stack direction="horizontal" gap={3}>
              <Button variant="outline-primary" active>
                  2024
                </Button>
                <Button variant="outline-primary">2023</Button>
              </Stack>
            </div> */}
            <h1 className="title">Recent Articles</h1>

            <div>
              {newsList
                .filter((x) => x.type === "News")
                .slice(0, 5)
                .map((item, index) => (
                  <div
                    className="sidebar-card cursor-pointer"
                    onClick={() => navigate(`/news/${item.slug}`)}
                  >
                    <Row className="flex-lg-row flex-md-column flex-row ">
                      <Col xl={5} md={12} xs={5}>
                        <img
                          alt={`news-img-${index}`}
                          src={item.image || alrajhi_logo}
                          width="100%"
                          style={{
                            objectFit: item.image ? `cover` : `scale-down`,
                          }}
                        />
                      </Col>
                      <Col className="content" xl={7} md={12} xs={7}>
                        <h1>{item.title}</h1>
                      </Col>
                    </Row>
                  </div>
                ))}
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default ViewNews;
